import { forwardRef, useEffect } from "react";
import { Typography } from "@mui/material";
import { TextField } from "@mui/material";
import { Button, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const OrganizationNameQuestion = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      value,
      latestStepQuestion,
      isEdit,
    },
    ref
  ) => {
    const nextQuestionHandler = (height, option) => {
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
    };

    const handleValue = (value) => {
      handlePayload(data, value);
    };

    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");
    return (
      <div
        style={{
          padding: isMobile ? "100px 0px" : "100px 20px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        ref={ref}
      >
        <>
          <Typography variant="subtitle1" sx={{ fontSize: "20px" }}>
            {t(data.question)}
          </Typography>
          <Grid container>
            <TextField
              id="outlined-basic"
              placeholder={t(data.label)}
              variant="outlined"
              multiline={data.multiline}
              rows={data.multiline && 3}
              fullWidth
              onChange={(e) => handleValue(e.target.value)}
              value={value}
            />
          </Grid>

          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={(option) => {
                  nextQuestionHandler(ref.current.clientHeight, value);
                }}
                disabled={!value}
                style={{ height: "50px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default OrganizationNameQuestion;
